<template>
    <aside class="my-aside">
        <nav>
            <ul>
                <li v-for="(item, index) in routerlists" :key="index" v-on:click="goToPage(item.link)">
                    <!-- <button class="btn-class" :class="{'current-tab': checkCurrentRoute(item.link)}" v-html="item.text"></button> -->
                    <button class="btn-class" v-html="item.text" v-bind:class="{active:currentPath == item.text}"></button>
                </li>
            </ul>
        </nav>
    </aside>
</template>

<script>
import { useRouter } from 'vue-router'
import {reactive } from 'vue'

export default {
    setup() {
        const router = useRouter()
        const isActive = (routerPath)=>{
            console.info("JBJB router.path "+router.currentRoute.path+", routerpath="+routerPath)
            return router.currentRoute.path === routerPath;
        }
        const currentPath = reactive({path:router.currentRoute.path})
        const routerlists = [
            { text: "대시보드", link: "/dashboard" },
            { text: "공지사항", link: "/notice" },
            { text: "이용가이드", link: "/guide" },
            { text: "개인 정보 처리 방침", link: "/policy" },
            { text: "이용약관", link: "/terms" },
        ]
        const goToPage = (target) => {
            if (router.currentRoute.path !== target) {
                router.push(target);
            }
        }
        return {
            currentPath,
            goToPage,
            isActive,
            routerlists
        }
    }
};
</script>

<style scoped>
.my-aside{
    width: 400px;
    height: calc(100vh - 78px);
    position: fixed;
    top: 78px;
    left: 0;
    background-color: #263238;
    padding: 40px 20px;
    opacity: 1;
}

nav {
    width: 360px;
    display: flex;
    flex-direction: column;
    gap: 60px;
}

ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
}

.btn-class{
    width: 100%;
    height: 68px;
    background-color: #263238;
    color: #E0E0E0;
    border: none;
    cursor: pointer;
    text-align: left;
    padding: 0 20px;
    transition: background-color 0.2s ease;
}

.btn-class:hover {
    background-color: #37474F;
}

.current-tab{
    width: 100%;
    height: 68px;
    color: #E0E0E0;
    background-color: #37474F;
}

.active{
    font-weight: bold;
    color: #FF0000;
}

/* 작은 화면 대응 */
@media (max-width: 1440px) {
    .my-aside {
        width: 300px;
    }
    nav {
        width: 260px;
    }
}

@media (max-width: 1024px) {
    .my-aside {
        width: 250px;
    }
    nav {
        width: 210px;
    }
}
</style>